import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { withRouter, Redirect, Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import * as userActions from "../../../actions/user";
import * as assayActions from "../../../actions/assays";
import * as cartActions from "../../../actions/addToCart";
import {
  removeSpaces,
  joinSpaces,
  processSearchParameter,
} from "../../../util/format";
import { validateCommercialID } from "../../../util/validations";
import _ from "underscore";
class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assaySearch: "",
      authenticating:props.authenticating,
      user:props.user
    };
  }
  

  handleSearch(e) {
    e.preventDefault();
    const submitSearch = e.keyCode === 13 || !e.keyCode;
    const {
      state: {
        form: {
          frmAssaySearch: { values },
        },
      },
    } = this.props;
    const searchString =
      values && values.assaySearch && values.assaySearch.trim();
    if (submitSearch) {
      this.setState({ assaySearch: searchString });
    }
  }

  render() {
    const { assaySearch } = this.state;

    const {
      match: {
        params: { assayCommercialId },
      },
      history,

    } = this.props;

    // check value from Nav bar is defined and trim spaces .
    const processedSearchValueFromNav =
      (!_.isUndefined(assaySearch) && assaySearch.trim()) || "";
    // encode the search value.
    const newEncodedSearchParams =
      (processedSearchValueFromNav !== "" &&
        encodeURI(processedSearchValueFromNav)) ||
      "";
    // Get the existing params from url if they exist.
    const searchParamterFromURL =
      (window.location.search &&
        window.location.search.replace("?", "") &&
        window.location.search.replace("?", "").trim()) ||
      "";

    // Decode the existing paramas if they exist.
    const existingSearchParamter = processSearchParameter(
      searchParamterFromURL
    );
    // If the processed Value is not "" else don't navigate or redirect
    if (processedSearchValueFromNav !== "") {
      
      // Check if it is a valid commercial ID and not the same as previously searched ID.
      if (
        validateCommercialID(processedSearchValueFromNav) && // Is it a valid commercial ID
        assayCommercialId !== processedSearchValueFromNav // Is it the same commercial ID

      ) {
        return <Redirect to={`/digital-assays/assay-detail/${assaySearch}`} />; // Redirect to assay-detail page.
      }
      if (
        !validateCommercialID(assaySearch) && // If not valid commercial ID
        existingSearchParamter !== processedSearchValueFromNav// Is it the same as previous search string

        ) {
        history.push({
          // Send it to search-results page.
          pathname: "/digital-assays/search-results",
          search: newEncodedSearchParams,
        });
      }
    }

    return (
      <div id="nav" className="d-print-none">
        <div className="row align-items-center">
          <div className="col">
            <Link to="/digital-assays" id="nav-home">
              Droplet Digital PCR Assays
            </Link>
          </div>
          <div className="col-5 d-flex align-items-center">
            <div className="input-group form-rounded">
              <div className="input-group-prepend">
                <span
                  className="input-group-text transparent-icon"
                  id="nav-search"
                >
                  <img
                    src={require("../../../digital-assays/assets/images/icons/Search-Idle.svg")}
                  />
                </span>
              </div>

              <Field
                component="input"
                type="text"
                name="assaySearch"
                className="form-control no-border search-place-holder"
                placeholder="Find an assay by Bio-Rad ID, Genbank Gene ID, Gene Name, or Cosmic ID"
                aria-describedby="nav-search"
                //normalize={joinSpaces}
                onKeyUp={(e) => {
                  e.stopPropagation();
                  this.handleSearch(e);
                }}
              />
            </div>
          </div>

          <div className="col">
            <Link to="/digital-assays/assay-design-history" id="nav-my-assays">
              <button className="outline rounded float-right">My Assays</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const stateToProps = (state, router) => ({ state, router });

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Object.assign({}, userActions, cartActions, assayActions),
  dispatch),
});

Nav = reduxForm({
  form: "frmAssaySearch",
  enableReinitialize: true,
})(Nav);

Nav = withRouter(connect(stateToProps, dispatchToProps)(Nav));

export default Nav;

Nav.propTypes = {
  state: PropTypes.object,
  match: PropTypes.object,
};
